<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 mb-2">
      <div class="breadcrumb-title mb-2 mt-md-0">
        <div class="d-flex align-items-center gap-2 ms-md-2 ms-0">
          <mat-icon class="text-primary"> group </mat-icon>
          <h5 class="mt-2">
            {{ applicationName }} {{ "applicationUsers.title" | translate }}
          </h5>
        </div>
      </div>
      <div class="col-md-12 mt-3">
        <div class="card pb-4 px-2">
          <div class="card-body pb-4">
            <div class="row align-items-center compact-inputs dropdown-pd-none">
              <div class="col-xxl-3 col-xl-4 col-md-10 col-sm-12 mb-2 px-1">
                <div class="d-flex justify-content-start align-items-center">
                  <div class="flex-grow-1">
                    <mat-form-field
                      appearance="outline"
                      subsriptSizing="dynamic"
                      class="w-100"
                    >
                      <mat-label>{{
                        "applicationUsers.search.placeholder" | translate
                      }}</mat-label>
                      <input matInput type="text" [(ngModel)]="searchText" />
                    </mat-form-field>
                  </div>

                  <button
                    mat-icon-button
                    class="icon-center icon-clean ms-1"
                    [matTooltip]="
                      'applicationUsers.search.placeholder' | translate
                    "
                    matTooltipPosition="above"
                  >
                    <mat-icon class="text-secondary icon-compact"
                      >info</mat-icon
                    >
                  </button>
                </div>
              </div>

              <div class="col-xxl-3 col-xl-4 col-md-10 col-sm-12 mb-2 px-1">
                <div class="d-flex justify-content-start align-items-center">
                  <div class="flex-grow-1">
                    <mat-form-field
                      appearance="outline"
                      subsriptSizing="dynamic"
                      class="w-100"
                    >
                      <mat-select
                        [(ngModel)]="selectedRoleId"
                        id="selectedRoleId"
                        name="selectedRoleId"
                      >
                        <mat-option value="">{{
                          "applicationUsers.search.rolePlaceholder" | translate
                        }}</mat-option>
                        <mat-option
                          *ngFor="let c of applicationRoles"
                          [value]="c['id']"
                          >{{ c["name"] }}</mat-option
                        >
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <button
                    mat-icon-button
                    class="icon-center icon-clean ms-1"
                    [matTooltip]="
                      'applicationUsers.search.rolePlaceholder' | translate
                    "
                    matTooltipPosition="above"
                  >
                    <mat-icon class="text-secondary icon-compact"
                      >info</mat-icon
                    >
                  </button>
                </div>
              </div>

              <div class="col-xxl-3 col-xl-4 col-md-10 col-sm-12 mb-2 px-1">
                <div class="d-flex justify-content-start align-items-center">
                  <div class="flex-grow-1">
                    <mat-form-field
                      appearance="outline"
                      subsriptSizing="dynamic"
                      class="w-100"
                    >
                      <mat-select [(ngModel)]="selectedStatus">
                        <mat-option value="">{{
                          "applicationUsers.search.statusPlaceholder"
                            | translate
                        }}</mat-option>
                        <mat-option value="Accept">{{
                          "applicationUsers.table.statusOptions.accept"
                            | translate
                        }}</mat-option>
                        <mat-option value="Reject">{{
                          "applicationUsers.table.statusOptions.reject"
                            | translate
                        }}</mat-option>
                        <mat-option value="Pending">{{
                          "applicationUsers.table.statusOptions.pending"
                            | translate
                        }}</mat-option>
                        <mat-option value="Cancel">{{
                          "applicationUsers.table.statusOptions.cancel"
                            | translate
                        }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <button
                    mat-icon-button
                    class="icon-center icon-clean ms-1"
                    [matTooltip]="
                      'applicationUsers.search.statusPlaceholder' | translate
                    "
                    matTooltipPosition="above"
                  >
                    <mat-icon class="text-secondary icon-compact"
                      >info</mat-icon
                    >
                  </button>
                </div>
              </div>

              <div class="col-auto mb-2 px-1">
                <button
                  mat-stroked-button
                  color="primary"
                  type="button"
                  (click)="searchUsers()"
                >
                  <mat-icon class="icon-compact">search</mat-icon>
                  {{ "applicationUsers.search.buttons.search" | translate }}
                </button>
              </div>
              <div class="col-auto mb-2 px-1">
                <button
                  mat-stroked-button
                  color="primary"
                  type="button"
                  (click)="search(); resetFilters()"
                >
                  <i class="fa fa-eraser"></i>
                  <span class="ms-2">{{
                    "applicationUsers.search.buttons.reset" | translate
                  }}</span>
                </button>
              </div>
              <div class="col-auto mb-2 px-1">
                <button
                  mat-stroked-button
                  color="primary"
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#inviteModal"
                >
                  <mat-icon class="icon-compact">mail_outline</mat-icon>
                  {{ "applicationUsers.search.buttons.invite" | translate }}
                </button>
              </div>
              <div class="col-auto mb-2 px-1">
                <button
                  mat-stroked-button
                  color="primary"
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#uploadModal"
                >
                  <mat-icon class="icon-compact">upload</mat-icon>
                  {{ "applicationUsers.search.buttons.bulkUpload" | translate }}
                </button>
              </div>
              <div class="col-auto mb-2 px-1">
                <button
                  mat-stroked-button
                  color="primary"
                  [title]="'APPLICATIONS.USERS' | translate"
                  [routerLink]="['/usecaseDatabase', appId]"
                  [queryParams]="{ fromUserButton: true }"
                >
                  <mat-icon class="icon-compact" style="font-size: 8px"
                    >group</mat-icon
                  >
                  {{
                    "applicationUsers.search.buttons.bulkUserList" | translate
                  }}
                </button>
              </div>
            </div>

            <div class="row">
              <!-- Table -->
              <div class="col-12 px-1">
                <div class="table-container mt-2">
                  <div class="table-responsive">
                    <table class="table table-bordered table-hover">
                      <thead>
                        <tr>
                          <th class="text-center" style="width: 5%">
                            {{
                              "applicationUsers.table.headers.sno" | translate
                            }}
                          </th>

                          <th class="text-nowrap sortable-header">
                            <span
                              class="header-label"
                              (click)="sortTable('email')"
                            >
                              {{
                                "applicationUsers.table.headers.name"
                                  | translate
                              }}
                              <ng-container
                                *ngTemplateOutlet="
                                  sortIcons;
                                  context: { key: 'email' }
                                "
                              ></ng-container>
                            </span>
                          </th>

                          <th class="text-nowrap sortable-header">
                            <span
                              class="header-label"
                              (click)="sortTable('applicationRoleName')"
                            >
                              {{
                                "applicationUsers.table.headers.role"
                                  | translate
                              }}
                              <ng-container
                                *ngTemplateOutlet="
                                  sortIcons;
                                  context: { key: 'applicationRoleName' }
                                "
                              ></ng-container>
                            </span>
                          </th>

                          <th
                            class="text-nowrap sortable-header"
                            style="width: 15%"
                          >
                            <span
                              class="header-label"
                              (click)="sortTable('status')"
                            >
                              {{
                                "applicationUsers.table.headers.status"
                                  | translate
                              }}
                              <ng-container
                                *ngTemplateOutlet="
                                  sortIcons;
                                  context: { key: 'status' }
                                "
                              ></ng-container>
                            </span>
                          </th>

                          <th class="text-center" style="width: 10%">
                            {{
                              "applicationUsers.table.headers.action"
                                | translate
                            }}
                          </th>
                        </tr>

                        <ng-template #sortIcons let-key="key">
                          <i
                            *ngIf="sortedField === key && sortOrder === 'ASC'"
                            class="fa fa-sort-up ms-1 text-dark"
                          ></i>
                          <i
                            *ngIf="sortedField === key && sortOrder === 'DESC'"
                            class="fa fa-sort-down ms-1 text-dark"
                          ></i>
                          <i
                            *ngIf="sortedField !== key"
                            class="fa fa-sort ms-1 text-muted"
                          ></i>
                        </ng-template>
                      </thead>
                      <tbody>
                        <tr *ngFor="let e of form.list; let i = index">
                          <td class="text-center" style="width: 5%">
                            {{ pageIndex(i) }}
                          </td>
                          <td>{{ e.email }}</td>
                          <td>{{ e.applicationRoleName }}</td>
                          <td *ngIf="e.status !== 'Accept'" style="width: 15%">
                            {{ e.status }}
                          </td>
                          <td *ngIf="e.status === 'Accept'" style="width: 15%">
                            <mat-form-field
                              appearance="outline"
                              subscriptSizing="dynamic"
                              class="compact-inputs w-100"
                            >
                              <mat-select
                                [(ngModel)]="e.status"
                                (selectionChange)="changeStatus(e.id, e.status)"
                              >
                                <mat-option value="" disabled>
                                  {{
                                    "applicationUsers.table.statusOptions.select"
                                      | translate
                                  }}
                                </mat-option>

                                <mat-option value="Accept">
                                  {{
                                    "applicationUsers.table.statusOptions.accept"
                                      | translate
                                  }}
                                </mat-option>

                                <mat-option value="Reject">
                                  {{
                                    "applicationUsers.table.statusOptions.reject"
                                      | translate
                                  }}
                                </mat-option>

                                <mat-option value="Pending">
                                  {{
                                    "applicationUsers.table.statusOptions.pending"
                                      | translate
                                  }}
                                </mat-option>

                                <mat-option value="Cancel">
                                  {{
                                    "applicationUsers.table.statusOptions.cancel"
                                      | translate
                                  }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </td>

                          <!-- Action Buttons -->
                          <td class="text-center" style="width: 10%">
                            <button
                              mat-stroked-button
                              color="warn"
                              type="button"
                              [matTooltip]="
                                'applicationUsers.table.actions.delete'
                                  | translate
                              "
                              (click)="delete(e.id)"
                              class="icon-center icon-width"
                            >
                              <mat-icon class="icon-compact">delete</mat-icon>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Pagination / Footer Component -->
          <app-list-header [$parent]="getSelf()"></app-list-header>
        </div>
      </div>
    </div>
  </div>

  <!-- Upload CSV Modal -->
  <div
    class="modal fade"
    id="uploadModal"
    tabindex="-1"
    aria-labelledby="uploadModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="uploadModalLabel">
            {{ "applicationUsers.modals.upload.title" | translate }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="resetForm()"
          ></button>
        </div>

        <div class="modal-body compact-inputs dropdown-pd-none">
          <!-- Alert messages remain the same as they're dynamic -->
          <p *ngIf="form['error'] == false && form['message']">
            <app-ncs-alert [message]="form['message']" type="success" />
          </p>
          <p *ngIf="form['error'] == true && form['message']">
            <app-ncs-alert [message]="form['message']" type="danger" />
          </p>
          <p *ngIf="form['searchError'] == false && form['searchMessage']">
            <app-ncs-alert [message]="form['searchMessage']" type="success" />
          </p>
          <p *ngIf="form['searchError'] == true && form['searchMessage']">
            <app-ncs-alert [message]="form['searchMessage']" type="danger" />
          </p>
          <div class="mb-3 d-flex align-items-center">
            <label class="me-2 mb-0" style="width: 100px">
              {{
                "applicationUsers.modals.upload.labels.selectRole" | translate
              }}
            </label>

            <mat-form-field appearance="outline" style="width: 280px">
              <mat-select
                id="applicationRoleInModal"
                name="applicationRoleInModal"
                [(ngModel)]="form.data['applicationRoleId']"
                placeholder="{{
                  'applicationUsers.search.rolePlaceholder' | translate
                }}"
                required
              >
                <mat-option disabled selected value="undefined">
                  {{ "applicationUsers.search.rolePlaceholder" | translate }}
                </mat-option>
                <mat-option
                  *ngFor="let c of applicationRoles"
                  [value]="c['id']"
                >
                  {{ c["name"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="mb-3 d-flex align-items-center">
            <label class="me-2 mb-0" style="width: 100px">
              {{
                "applicationUsers.modals.upload.labels.selectCSV" | translate
              }}
            </label>

            <mat-form-field appearance="outline" style="width: 280px">
              <!-- Hidden file input -->
              <input
                type="file"
                hidden
                #fileInput
                id="csvFile"
                (change)="confirmUpload($event)"
                accept=".csv"
                [disabled]="
                  !form.data['applicationRoleId'] ||
                  form.data['applicationRoleId'] === 'undefined'
                "
              />

              <input
                matInput
                [value]="selectedCsvFile ? selectedCsvFile.name : ''"
                placeholder="{{
                  'ALLREMAININGS.Common_Select_File' | translate
                }}"
                readonly
                [disabled]="
                  !form.data['applicationRoleId'] ||
                  form.data['applicationRoleId'] === 'undefined'
                "
                (click)="fileInput.click()"
                style="cursor: pointer"
              />

              <button
                mat-icon-button
                matSuffix
                type="button"
                class="icon-pd-none"
                [disabled]="
                  !form.data['applicationRoleId'] ||
                  form.data['applicationRoleId'] === 'undefined'
                "
                (click)="fileInput.click(); $event.stopPropagation()"
                [title]="selectedCsvFile ? 'Change file' : 'Select file'"
              >
                <mat-icon class="icon-compact">attach_file</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <div class="mb-3 d-flex align-items-center">
            <label class="form-label me-2 mb-0" style="width: 100px">
              {{
                "applicationUsers.modals.upload.labels.sampleFile" | translate
              }}
            </label>

            <button
              mat-stroked-button
              color="primary"
              [title]="'COMMON.Download' | translate"
              (click)="uploadBulkUserSampleCsv()"
            >
              <mat-icon>download</mat-icon>
              {{ "ALLREMAININGS.DOWNLOAD" | translate }}
            </button>
          </div>
        </div>

        <div class="modal-footer">
          <!-- Upload Button -->
          <button
            mat-stroked-button
            color="primary"
            class="btn-sm me-1"
            (click)="onCsvFileUpload()"
            [disabled]="
              !form.data['applicationRoleId'] ||
              form.data['applicationRoleId'] === 'undefined' ||
              !selectedCsvFile
            "
          >
            <mat-icon>upload</mat-icon>
            {{ "ALLREMAININGS.Upload" | translate }}
          </button>

          <!-- Close Button -->
          <button
            mat-stroked-button
            color="warn"
            class="btn-sm ml-2"
            data-bs-dismiss="modal"
            [title]="'COMMON.CLOSE' | translate"
            (click)="resetForm()"
          >
            <mat-icon>close</mat-icon>
            {{ "COMMON.CLOSE" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="inviteModal"
    tabindex="-1"
    aria-labelledby="inviteModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="inviteModalLabel">
            {{ "ALLREMAININGS.INVITE_USER" | translate }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="resetForm(); resetselectemails()"
          ></button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body">
          <!-- Success & Error Messages -->
          <p *ngIf="form['error'] === false && form['message']">
            <app-ncs-alert
              [message]="form['message']"
              type="success"
            ></app-ncs-alert>
          </p>
          <p *ngIf="form['error'] === true && form['message']">
            <app-ncs-alert
              [message]="form['message']"
              type="danger"
            ></app-ncs-alert>
          </p>
          <p *ngIf="form['searchError'] === false && form['searchMessage']">
            <app-ncs-alert
              [message]="form['searchMessage']"
              type="success"
            ></app-ncs-alert>
          </p>
          <p *ngIf="form['searchError'] === true && form['searchMessage']">
            <app-ncs-alert
              [message]="form['searchMessage']"
              type="danger"
            ></app-ncs-alert>
          </p>

          <form #uiForm="ngForm" class="compact-inputs dropdown-pd-none">
            <!-- Role Dropdown -->
            <div class="mb-3 d-flex align-items-center">
              <label class="form-label me-2 mb-0" style="width: 100px">
                {{ "ALLREMAININGS.Select_Role" | translate }}
              </label>

              <mat-form-field appearance="outline" style="width: 280px">
                <mat-select
                  id="applicationRoleInModal"
                  name="applicationRoleInModal"
                  [(ngModel)]="form.data['applicationRoleId']"
                  required
                  placeholder="{{ 'ALLREMAININGS.Select_Role' | translate }}"
                >
                  <mat-option disabled value="undefined">
                    {{ "applicationUsers.search.rolePlaceholder" | translate }}
                  </mat-option>
                  <mat-option
                    *ngFor="let c of applicationRoles"
                    [value]="c['id']"
                  >
                    {{ c["name"] }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Email Input -->
            <div class="mb-3 d-flex align-items-start flex-column">
              <div class="d-flex align-items-center">
                <label class="form-label me-2 mb-0" style="width: 100px">
                  {{ "ALLREMAININGS.EMAIL" | translate }}
                </label>
                <mat-form-field appearance="outline" style="width: 280px">
                  <input
                    matInput
                    type="email"
                    id="email"
                    name="email"
                    placeholder="{{ 'ALLREMAININGS.EMAIL_PLACE' | translate }}"
                    [(ngModel)]="emailInput"
                    (keydown.enter)="addEmail($event)"
                    (input)="clearEmailError()"
                  />
                </mat-form-field>
              </div>
              <mat-chip-listbox class="d-flex gap-2 flex-wrap mt-2">
                <mat-chip
                  *ngFor="let e of emailList; let i = index"
                  class="email-chip me-1 mb-1"
                  removable
                  (removed)="removeEmail(i)"
                >
                  {{ e }}
                  <mat-icon matChipRemove>close</mat-icon>
                </mat-chip>
              </mat-chip-listbox>

              <!-- Error Message -->
              <div *ngIf="emailError" class="text-danger mt-1">
                {{ emailError }}
              </div>
            </div>
          </form>
          <!-- Form End -->
        </div>
        <div class="modal-footer">
          <button
            mat-stroked-button
            color="primary"
            class="me-2"
            (click)="save()"
            [disabled]="
              !form.data['applicationRoleId'] ||
              form.data['applicationRoleId'] === 'undefined'
            "
          >
            <mat-icon>mail_outline</mat-icon>
            {{ "ALLREMAININGS.INVITE" | translate }}
          </button>

          <button
            mat-stroked-button
            color="warn"
            data-bs-dismiss="modal"
            [title]="'applicationUsers.modals.invite.buttons.close' | translate"
            (click)="resetForm(); resetselectemails()"
          >
            <mat-icon>close</mat-icon>
            {{ "COMMON.CLOSE" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Bootstrap Modal for Errors -->
  <div
    class="modal fade"
    id="errorModal"
    tabindex="-1"
    aria-labelledby="errorModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="errorModalLabel">
            Upload Errors (with Row Numbers)
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="table-container">
            <div class="table-responsive">
              <table class="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th class="text-center">Row Number</th>
                    <th>Error Message</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let error of errorList">
                    <td class="text-center">{{ error.rowNumber }}</td>
                    <td>{{ error.message }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            mat-stroked-button
            color="warn"
            type="button"
            data-bs-dismiss="modal"
          >
            <mat-icon>close</mat-icon> {{ "ALLREMAININGS.Close" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
